import { useEffect } from 'react';
import { Capacitor, SystemBars } from '@capacitor/core';

/**
 * useSystemBarsStyle — status-bar icon colour for the surface under it.
 *
 * Week 4 store build (Capacitor 8, Sept 2026): the app is edge-to-edge on both
 * platforms, so the status bar sits over whatever the page puts at the top.
 * Pages with the green Navbar (or the charcoal staff-portal header) want light
 * icons — Capacitor calls that style 'DARK', named for the background. Every
 * other page is cream, so the boot default in capacitor.config.ts is 'LIGHT'
 * (dark icons) and this hook restores it on unmount. Web renders nothing and
 * calls nothing.
 */
export function useSystemBarsStyle(style) {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;
    SystemBars.setStyle({ style }).catch(() => {});
    return () => { SystemBars.setStyle({ style: 'LIGHT' }).catch(() => {}); };
  }, [style]);
}
